<app-functie-detail [functieSlug]="functieSlug"></app-functie-detail>
